<kendo-dropdownlist
   [data]="callProgressPossibleStates"
   [value]="progressState$ | async"
   [valueField]="'value'"
   [textField]="'value'"
   class="sam-full-width"
   [valuePrimitive]="false"
   (selectionChange)="changeProgressType($event)"
>
   <ng-template kendoDropDownListValueTemplate let-dataItem>
      <fa-icon
         kendoTooltip
         [title]="dataItem.translationKey | translate"
         class="sam-margin-right"
         *ngIf="dataItem"
         [icon]="dataItem.icon"
         [ngClass]="dataItem.styleClass"
      ></fa-icon>
   </ng-template>
   <ng-template kendoDropDownListItemTemplate let-dataItem>
      <samweb-call-progress-item [callProgressState]="dataItem"> </samweb-call-progress-item>
   </ng-template>
</kendo-dropdownlist>
